import { createSlice } from "@reduxjs/toolkit";

export const modeSlice = createSlice({
  name: "mode",
  initialState: {
    value: "AUTO_CAPTURE",
  },
  reducers: {
    update: (state, action) => {
      state.value = action.payload;
    },
    reset: (state) => {
      state.value = "AUTO_CAPTURE";
    },
  },
});

export const { update, reset } = modeSlice.actions;

export default modeSlice.reducer;
